import { useContext, useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from "styled-components";

import { CoreContext } from 'context/CoreContext';
import { getTheme } from './theme-color';

export function ThemedComponent({ children }) {
    const { themeMode } = useContext(CoreContext);
    const theme = useMemo(() => getTheme(themeMode), [themeMode]);

    return <ThemeProvider theme={theme}>
        <StyledThemeProvider theme={theme}>
            { children }
        </StyledThemeProvider>
    </ThemeProvider>
}
